import i18n from "../../i18n";

export const getMediaPickerTitle = (targetType) =>
  targetType && i18n.exists(`mediaPicker.${targetType}`)
    ? i18n.t(`mediaPicker.${targetType}`)
    : i18n.t("fields.selectImage");

export const getMediaPickerEmptyMessage = (targetType) => {
  const label =
    targetType && i18n.exists(`mediaPicker.${targetType}`)
      ? i18n.t(`mediaPicker.${targetType}`)
      : null;
  return label
    ? i18n.t("mediaPicker.emptyTyped", { label: label.toLowerCase() })
    : i18n.t("mediaPicker.empty");
};
